import styles from "./HeroSection.module.css";

const HeroSection = () => {
  return (
    <div className={styles.HeroSection}>
      <div className={styles.HeroText}>
        <p>The wedding of:</p>
        <h1>
          Adam
          <br />
          &
          <br />
          Laura
        </h1>
        <p>Come and celebrate with us!</p>
      </div>
      <aside className={styles.SideImage}>
        <img src="./adam-and-laura.jpg" alt="" />
      </aside>
    </div>
  );
};

export default HeroSection;
